import { render, staticRenderFns } from "./remark-form.vue?vue&type=template&id=2af085e0&"
import script from "./remark-form.vue?vue&type=script&lang=js&"
export * from "./remark-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports